import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../guard/auth.guard'
import { ProveedoresComponent } from './proveedores.component'
import { VerProveedoresComponent } from './ver-proveedores/ver-proveedores.component'

const routes: Routes = [
  {
    path: '',
    component: ProveedoresComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: VerProveedoresComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProveedoresRoutingModule {}
